import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';

import stockLocationKeys from './keyFactory';

const GetStockLocation = graphql(`
  query StockLocation($id: ID!) {
    stockLocation(id: $id) {
      id
      name
      notes
      archivedAt
      address {
        id
        line1
        line2
        city
        administrativeArea
        postalCode
        country
      }
      materialsList {
        id
        stockValueExcTax {
          valueInMinor
          currency {
            id
            code
            exponent
          }
        }
      }
    }
  }
`);

const useGetStockLocation = (id: string | undefined) => {
  const { data, ...rest } = useQuery({
    queryKey: stockLocationKeys.detail(id ?? ''),
    queryFn: () => gqlClient.request(GetStockLocation, { id: id! }),
    enabled: !!id,
  });

  return { stockLocation: data?.stockLocation, ...rest };
};

export default useGetStockLocation;
